/**
 * VF Loyalty points redeem Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var Form = require('class/form.class');
    var BaseReplacerView = require('common/base.replacer.view');
    var userValidationConfig = require('modules/user/user.validation.config');
    var LoyaltyPointsRedeemModel = require('replacers/bingo-replacers/loyalty-points-redeem.model');

    module.exports = BaseReplacerView.extend({

        model: new LoyaltyPointsRedeemModel(),

        accessRules: {
            allow: ['user']
        },

        events: {
            'keyup #fn-points' : 'updatePoints',
            'change #fn-bonus-type' : 'updateConversionRate',
            'submit .fn-form' : 'redeem'
        },

        initialize: function() {
            // prevent possible fuck up with binding wrong render when checkAccess() is set to false
           this.checkAccess() && this.updateModel();
        },

        updateModel: function() {
            this.model.fetch(
                {
                    success: this.handleSuccessFetch.bind(this),
                    error: this.handleFailFetch.bind(this)
                }
            );
        },

        handleSuccessFetch: function() {
            this.render();

            this.updateConversionRate();
        },

        handleFailFetch: function(model, response) {
            // 89521, 89525
            var tKey = 'playtech.mobile.system.loyaltyRedeem.info.fetchError.' + response.ID;
            this.showInfo({ content: this.translate(tKey), variant: this.toastVariants.ERROR });

            this.$el.html(this.translate(tKey));
        },

        handleRedeemDone: function(amount) {
            this.showInfo({
                content:  this.translate('playtech.mobile.system.loyaltyRedeem.info.redeemSuccess', amount),
                variant: this.toastVariants.SUCCESS
            });

            this.updateModel();
        },

        handleRedeemError: function(response) {
            this.form.hideLoading();

            // 89526
            var tKey = 'playtech.mobile.system.loyaltyRedeem.info.redeemError.' + response.ID;
            this.showInfo({
                content: this.translate(tKey),
                variant: this.toastVariants.ERROR
            });
        },

        updatePoints: function() {
            var points = Math.max(parseFloat(this.form.data('points')), 0);
            var $amount = this.$('#fn-amount');
            var amount = points * this.conversionRate;

            amount = this.roundToDecimal(amount);

            $amount.val(
                amount
                    ? window.Playtech.API.formatter.formatCurrency(amount, { precision: 2 })
                    : ''
            )
                .trigger('change');
        },

        updateConversionRate: function(e, balanceType) {
            var $rateElement = this.$('.fn-conversion-rate');

            balanceType = e ? $(e.currentTarget).val() : '';
            balanceType = balanceType || this.model
                    .get('data')
                    .scheme
                    .redemptionBalances
                    .balances[0]
                    .balanceType;

            this.conversionRate = this.model.get('data').conversionRates[balanceType] / 100;

            this.userConversationRate = parseFloat(this.conversionRate.toFixed(4));

            $rateElement.html(
                this.translate('playtech.mobile.system.loyaltyRedeem.form.conversionRate', this.userConversationRate)
            );

            if (this.form.data('points') && this.form.data('points').length) {
                this.form.validate();
            }

            this.updatePoints();
        },

        redeem: function(e) {
            e.preventDefault();

            this.form.validate().done(function(data, form) {
                form.showLoading();

                this.model
                    .redeemPoints({
                        amount: data.points,
                        balanceType: data['bonus-type']
                    })
                    .done(this.handleRedeemDone.bind(this, data.amount))
                    .fail(this.handleRedeemError.bind(this));
            }.bind(this));
        },

        render: function() {
            var modelData = this.model.toJSON();

            this.$el.html(this.tmpl('loyalty-points-redeem', modelData));

            this.form = new Form(this.$('.fn-form'), {
                validationConfig: userValidationConfig()
            });

            this.form.loyaltyMinValues = modelData && modelData.data ? modelData.data.minRedeemValues : 0;
            this.form.loyaltyMaxValue = modelData && modelData.data ? modelData.data.points.balance : 0;

            if (!modelData.data) {
                this.form.showLoading();
            }

            return this;
        },

        /**
         *  Formats amount to the decimals in low value
         */
        roundToDecimal: function(amount) {
            let concatAmount;

            if (isNaN(amount)) {
                return '';
            }

            concatAmount = amount.toString();
            concatAmount = concatAmount.split('.');

            if (concatAmount.length > 1) {
                concatAmount[1] = concatAmount[1].substr(0, 2);
            }

            return concatAmount.join('.');
        }
    }, {
        nameOfReplacers: [
            'VF_LOYALTY_POINTS_REDEEM'
        ]
    });
});
